export function rgFormatter(rg: string) {
  if (rg) return rg.replace(/(\d{2})(\d{3})(\d{3})(\d{1})$/, "$1.$2.$3-$4");
  return "";
}
